import React from "react";

import { IAnswerR, IAnswer } from "../../../state";

import styles from "./FormComment.module.scss";

type Props = {
  answer: IAnswerR | IAnswer;
  calling?: boolean;
  replyAnswer: (content: string, answer_id: number) => void;
};

const FormComment: React.FC<Props> = ({ answer, replyAnswer, calling }) => {
  const [content, setContent] = React.useState<string>("");
  return (
    <div className={styles.form}>
      <textarea
        className={styles.textarea}
        value={content}
        rows={3}
        placeholder="コメントを入力してください。"
        onChange={e => setContent(e.target.value)}
      />
      <div className={styles.buttonGroup}>
        <button
          className={styles.submitButton}
          disabled={calling || !content}
          onClick={e => {
            e.preventDefault();
            replyAnswer(content, answer.id);
            setContent("");
          }}
        >
          コメントを送信する
        </button>
      </div>
    </div>
  );
};

export default FormComment;
